import React from 'react';
import { showInformationToast } from '@spotahome/ui-library';
import { trans } from '@spotahome/bff/client';
import '@spotahome/ui-library/lib/components/Toast.css';

import { cityInformation } from './informationToastUtils';

import TimerIcon from './../icons/TimerIcon';

const TOAST_EXIT_TIMEOUT = 8000;
const InformationToastWrapper = (typeOfMessage, city) => {
  const toastProps = {
    renderIcon: () => <TimerIcon />,
    renderContent: () => trans(cityInformation(typeOfMessage, city))
  };

  return showInformationToast(toastProps, {
    autoClose: TOAST_EXIT_TIMEOUT
  });
};

export default InformationToastWrapper;
